import TooltipContent from 'components/common/TooltipContent';
import { useUserState } from 'context/User';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import CustomNotifications from './CustomNotifications';
import { UserPreferencesModel } from './UserPreferencesModel';
import { UserStateContextType } from 'components/constants/Constants';
import { ProfileTitleSection } from '../user/UserProfile/UserProfile';
import {
  Box,
  Card,
  CardContent,
  FormControlLabel,
  Switch
} from '@mui/material';
import { FieldValues, UseFormReturn } from 'react-hook-form';

interface props {
  tab: 'profile' | 'preferences';
  methods: UseFormReturn<FieldValues, any, undefined>;
}
export const UserPreferences = ({ tab, methods }: props) => {
  const { t } = useTranslation();

  const {
    getPreferences,
    preferences,
    updatePreferences,
    onNewsLetterChangeHandler,
    getPhoneNumber,
    phoneNumber
  } = UserPreferencesModel();
  useEffect(() => {
    getPreferences();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getPhoneNumber();
    //check again if the user changed the tab
    //ideally we could check when the value is updated but since this is a temporary fix leave it like this for now
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);
  const userState = useUserState();
  const user =
    userState.type === UserStateContextType.AUTHENTICATED
      ? userState.user
      : undefined;
  if (user === undefined) return null;
  const newsletter = methods.getValues().newsletter ?? false;
  return (
    <>
      <Card>
        <CardContent>
          <ProfileTitleSection title={'Email notifications'} />

          {/* //temporary fix until the backend does the solution from their side */}
          <TooltipContent
            showTooltip={phoneNumber === undefined}
            title="Please update your phone number in the Profile Tab first"
          >
            <Box
              sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}
            >
              <FormControlLabel
                control={
                  <Switch
                    disabled={phoneNumber === undefined}
                    onChange={e => onNewsLetterChangeHandler(e.target.checked)}
                    defaultChecked={newsletter}
                    name="newsletter"
                    id="newsletter"
                  />
                }
                label={t(`user.preferences.newsletter.title`)}
              />
            </Box>
          </TooltipContent>
          {preferences?.notifications &&
            Object.keys(preferences?.notifications).map((notification: any) => {
              const value = preferences.notifications?.[notification];

              return (
                <div key={notification}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      mb: 1
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          name={notification}
                          id={notification}
                          defaultChecked={value}
                          onChange={e => {
                            updatePreferences(
                              `notifications.${notification}`,
                              e.target.checked
                            );
                          }}
                        />
                      }
                      label={t(`user.preferences.${notification}.title`)}
                    />
                  </Box>
                </div>
              );
            })}
        </CardContent>
      </Card>

      {user?.brandPortalEvent?.map(piEvent => (
        <CustomNotifications key={piEvent.key} brandPortalEvent={piEvent} />
      ))}
    </>
  );
};
